export function CalculatedBadge({ label, value, unit, category, categoryColor, testId }) {
  return (
    <div
      data-testid={testId}
      className="flex justify-between items-center mb-3 rounded-[14px]"
      style={{
        background: "linear-gradient(135deg, #FCFAEE 0%, #F0EAD6 100%)",
        border: "1px solid #E2D9CB",
        padding: "12px 16px",
      }}
    >
      <div
        className="text-[11px] font-semibold uppercase tracking-wide"
        style={{ color: "#71644C" }}
      >
        {label}
      </div>
      <div className="flex items-center gap-2">
        <span
          className="text-[22px] font-extrabold"
          style={{ color: "#2D2A24" }}
        >
          {value}
        </span>
        {unit && (
          <span className="text-[11px]" style={{ color: "#71644C" }}>
            {unit}
          </span>
        )}
        {category && (
          <span
            className="text-[11px] font-bold rounded-lg"
            style={{
              padding: "3px 9px",
              background: `${categoryColor}18`,
              color: categoryColor,
            }}
          >
            {category}
          </span>
        )}
      </div>
    </div>
  );
}
